<div class="question-management-container">
  <h2>題目管理系統</h2>

  <div class="search-section">
    <div class="search-controls">
      <div class="form-group">
        <label for="subject">選擇科目</label>
        <select id="subject" [(ngModel)]="selectedSubject" class="form-control" required>
          <option *ngFor="let subject of subjects" [value]="subject">
            {{subject}}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="keyword">關鍵字搜尋</label>
        <input type="text" id="keyword" [(ngModel)]="searchKeyword" placeholder="輸入關鍵字" class="form-control">
      </div>

      <div class="button-group">
        <button class="btn btn-primary" (click)="searchQuestions()" [disabled]="!selectedSubject">搜尋</button>
        <button class="btn btn-secondary" (click)="openEditModal()" [disabled]="!selectedSubject">新增題目</button>
      </div>
    </div>

    <div class="search-hint" *ngIf="!selectedSubject">
      請選擇科目才能進行搜尋或新增題目
    </div>
  </div>

  <!-- Loading indicator -->
  <div class="loading-indicator" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>資料載入中...</p>
  </div>

  <div class="results-section" *ngIf="!isLoading && questions.length > 0">
    <table class="question-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>題目內容</th>
          <th>選項</th>
          <th>正確答案</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let question of questions">
          <td>{{question.id}}</td>
          <td>{{question.text}}</td>
          <td>
            <div *ngFor="let option of question.options; let i = index">
              {{i + 1}}. {{option}}
            </div>
          </td>
          <td>
            <span *ngFor="let index of question.correctAnswerIndex">
              {{index}}
            </span>
          </td>
          <td>
            <button class="btn btn-edit" (click)="openEditModal(question)">編輯</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="no-results" *ngIf="!isLoading && questions.length === 0 && (selectedSubject || searchKeyword)">
    沒有找到符合條件的題目
  </div>

  <!-- Simple Edit Modal -->
  <div *ngIf="isEditModalOpen" class="simple-modal-container">
    <div class="simple-modal-backdrop" (click)="closeEditModal()"></div>
    <div class="simple-modal">
      <div class="simple-modal-header">
        <h3>{{editingQuestion?.id ? '編輯題目' : '新增題目'}}</h3>
        <button class="simple-close-button" (click)="closeEditModal()">&times;</button>
      </div>
      <div class="simple-modal-body">
        <!-- Replace the subject dropdown in the modal with a read-only field -->
        <div class="form-group">
          <label for="edit-subject">科目</label>
          <input
            type="text"
            id="edit-subject"
            [value]="editingQuestion!.SbjectId"
            class="form-control read-only-field"
            readonly>
        </div>

        <div class="form-group">
          <label for="edit-text">題目內容</label>
          <textarea id="edit-text" [(ngModel)]="editingQuestion!.text" class="form-control" rows="3"></textarea>
        </div>

        <div class="options-container">
          <h4>選項</h4>
          <div *ngFor="let option of editingQuestion!.options; let i = index" class="option-row">
            <textarea
              [(ngModel)]="editingQuestion!.options[i]"
              [ngModelOptions]="{updateOn: 'blur'}"
              placeholder="選項內容"
              [id]="'option-' + i"
              class="form-control"
              rows="2"
            ></textarea>
            <label>
              <input type="radio" name="correct" [checked]="isCorrectAnswer(i)" (change)="setCorrectAnswer(i)">
              正確答案
            </label>
            <button *ngIf="editingQuestion!.options.length > 2" (click)="removeOption(i, $event)">刪除</button>
          </div>
          <button (click)="addOption()">新增選項</button>
        </div>
      </div>
      <div class="simple-modal-footer">
        <!-- Only show delete button when editing an existing question (has ID) -->
        <button
          *ngIf="editingQuestion?.id"
          type="button"
          class="btn btn-danger"
          (click)="deleteQuestion()">
          刪除題目
        </button>
        <button type="button" class="btn btn-cancel" (click)="closeEditModal()">取消</button>
        <button type="button" class="btn btn-save" (click)="saveQuestion()">儲存</button>
      </div>
    </div>
  </div>
</div>
